import styles from "./styles/CreateNewCard.module.css";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
// import QurealSpotlight from "./QurealSpotlight";

function CreateNewCard({ selected_type, setSelectedType, me }) {
    const [type, setType] = useState(selected_type);

    useEffect(() => {
        setSelectedType(type);
    }, [type]);

    useEffect(() => {
        setType(selected_type);
    }, [selected_type]);

    return (
        <div className={styles.wrapper}>
            {/* <h4 className={styles.welcome_text}>Hello Shivam</h4> */}
            <div className={styles.top_wrapper}>
                <h3 className={styles.ask_text}>
                    {me?.first_name}, Let's create something awesome today!
                </h3>
                {/* <QurealSpotlight me={me} /> */}
            </div>

            <div className={styles.items_bar}>
                <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: type === "all_creation",
                    })}
                    onClick={() => setType("all_creation")}
                >
                    All
                </div>
                <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: type === "website",
                    })}
                    onClick={() => setType("website")}
                >
                    Website
                </div>
                <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: type === "singlepage",
                    })}
                    onClick={() => setType("singlepage")}
                >
                    Social Media
                </div>
                {/* <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: selected_type === "slider",
                    })}
                    onClick={() => setSelectedType("slider")}
                >
                    Slider
                </div> */}
                <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: type === "document",
                    })}
                    onClick={() => setType("document")}
                >
                    Document
                </div>
                <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: arraysEqual(type, [
                            "magazine",
                            "slider",
                            "flipbook",
                        ]),
                    })}
                    onClick={() => setType(["magazine", "slider", "flipbook"])}
                >
                    Magazine
                </div>
                {/* <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: selected_type === "qdf",
                    })}
                    onClick={() => setSelectedType("qdf")}
                >
                    QDF
                </div> */}
                {/* <div
                    className={classNames(styles.item_wrapper, {
                        [styles.active]: selected_type === "packaging_box",
                    })}
                    onClick={() => setSelectedType("packaging_box")}
                >
                    Box Packaging
                </div> */}
            </div>
            {/* <AllCreations /> */}
        </div>
    );
}

export default CreateNewCard;
//inspiration
//https://new.express.adobe.com/?referrer=https%3A%2F%2Fwww.google.com%2F&url=%2Fexpress%2F&ctaid=marquee&_branch_match_id=1250850696368271814&_branch_referrer=H4sIAAAAAAAAAxWLwQrCMBAFv6YeE9CbEMQcKnjyIp637bMtTd11NyV%2BvikMDAzMlLPY2XsauIMJ6SJs2ZGIS%2FNn8be7xkf7fMXYXRRvqELDtE%2FN6doc20opxY3MY4Lrea3hsGkK1fiJwmwvfaZ5CCvpdwP%2BGhWAO3QAAAA%3D

function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((val, index) => val === arr2[index]);
}
